import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    InspeccionSubmitPostRequest,
    TInspeccionViewModel,
    TRechazoParcialSolicitudViewModel,
    TwSolicitudFrSanidadExtViewModel,
    TwSolicitudFrViewModel,
} from './inspecciones.types';
import { SolicitudProductosViewModel } from '../productos/productos.types';
import { AsyncInfoResponseViewModel } from '../../../core/components/asyncInfo/asyncInfo.types';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class InspeccionesService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getLongTimeOutHeaders(): HttpHeaders {
        return new HttpHeaders({ timeout: `${300000}` });
    }

    getInspeccion(id: number): Observable<TInspeccionViewModel> {
        return this.http.get<TInspeccionViewModel>(this.baseUrl + 'api/importacion/inspecciones/' + id).pipe();
    }

    getEquipamientos(id: number): Observable<SolicitudProductosViewModel> {
        return this.http.get<SolicitudProductosViewModel>(this.baseUrl + 'api/importacion/inspecciones/Equipamientos/' + id).pipe();
    }

    getFr(id: number): Observable<TwSolicitudFrViewModel[]> {
        return this.http.get<TwSolicitudFrViewModel[]>(this.baseUrl + 'api/importacion/inspecciones/fr/' + id).pipe();
    }

    getFrSanidadExt(id: number): Observable<TwSolicitudFrSanidadExtViewModel[]> {
        return this.http.get<TwSolicitudFrSanidadExtViewModel[]>(this.baseUrl + 'api/importacion/inspecciones/frSanidadExt/' + id).pipe();
    }

    rechazoParcial(listRechazoParcial: TRechazoParcialSolicitudViewModel[]): Observable<any> {
        return this.http.post<TRechazoParcialSolicitudViewModel[]>(this.baseUrl + 'api/importacion/inspecciones/RechazoParcial', listRechazoParcial).pipe();
    }

    createInspeccion(inspeccion: TInspeccionViewModel): Observable<any> {
        return this.http.post<TInspeccionViewModel>(this.baseUrl + 'api/importacion/inspecciones', inspeccion).pipe();
    }

    editInspeccion(inspeccion: TInspeccionViewModel): Observable<any> {
        return this.http.put<TInspeccionViewModel>(this.baseUrl + 'api/importacion/inspecciones', inspeccion).pipe();
    }

    revisionSolicitante(params: HttpParams): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'api/importacion/inspecciones/RevisionSolicitante/', { params: params }).pipe();
    }

    //submit(id: number): Observable<AsyncInfoResponseViewModel> {
    //    return this.http
    //        .get<any>(this.baseUrl + 'api/importacion/inspecciones/Submit/' + id, {
    //            headers: this.getLongTimeOutHeaders(),
    //        })
    //        .pipe();
    //}
}
